// extracted by mini-css-extract-plugin
export default {"TextInput":"styles_TextInput__-y106","descriptionInputStyle":"styles_descriptionInputStyle__xeUuj","label":"styles_label__dBmw3"};